import { render, staticRenderFns } from "./SynergridMoveRequestForm.vue?vue&type=template&id=59fc4b27"
import script from "./SynergridMoveRequestForm.vue?vue&type=script&lang=ts"
export * from "./SynergridMoveRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports